import { dateTimeWithMicroFormatter } from "../utils/formatter/date-formatter";

export const AUTH_MESSAGE = `Login Stomatrade: ${dateTimeWithMicroFormatter(new Date())}`;